import React from 'react'
import InViewMonitor from 'react-inview-monitor'

import AnimatedNumber from './AnimatedNumber'

function AnimatedSvgCirclePathInView ({ strokeColor, percentage }) {
  return (
    <InViewMonitor
      classNameNotInView='technology-page__stack-section__figure animated-svg mb2 relative'
      classNameInView='technology-page__stack-section__figure animated-svg relative mb2 running'
    >
      <svg viewBox='0 0 362 362' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none' fillRule='evenodd'>
          <g>
            <circle
              stroke='#E4E6F4'
              strokeWidth='31'
              strokeLinecap='round'
              cx='180.5'
              cy='180.5'
              r='165'
            />
            <circle
              className='technology-page__stack-section__figure animated-svg__path'
              stroke={strokeColor}
              strokeWidth='31'
              strokeLinecap='round'
              strokeLinejoin='round'
              cx='180.5'
              cy='180.5'
              r='165'
            />
          </g>
          <g className='technology-page__stack-section__figure animated-svg__dot'>
            <rect width='362' height='362' />
            <circle fill='#fff' cx='180.5' cy='15.5' r='15.5' />
          </g>
        </g>
      </svg>
      <div className='h3 absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center'>
        <AnimatedNumber finalNumber={percentage} />
        <span> %</span>
      </div>
    </InViewMonitor>
  )
}

export default AnimatedSvgCirclePathInView



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/AnimatedSvgCirclePathInView.js